export const btnDesign = () => {
    const btns = document.querySelectorAll('.btn');

    // Cloning the btn text for animation.
    btns.forEach(e => {
        let btnTextLength = e.querySelectorAll('.btn__text').length;
        let i = 0;
        if (btnTextLength < 2){
            while (i < 2) {
                e.appendChild(e.querySelector('.btn__text').cloneNode(true));
                i++;
            }
        }
    });
}